import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Typography } from 'antd';
import AuthLayout from '../../../Layout/AuthLayout';
import { getRoutes } from '../../../constants/Routes';
import { resetPassword } from '../../../redux/actions/auth';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import { sendPasswordChangedEmail } from '../../../redux/actions/email';

const ResetPassword = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { token } = queryString.parse(location.search);
    const [user, setUser] = useState({})

    const handleResetPassword = async (body) => {
        const { password } = body
        const res = await resetPassword({ newPassword: password, token });
        if (res?.ack) {
            await sendPasswordChangedEmail({
                user,
                userEmail: user?.email
            })
            navigate(getRoutes().login.route());
        }
    };

    useEffect(() => {
        if (!token) navigate('/')
        else {
            const paresJWT = JSON.parse(atob(token.split('.')[1]))
            setUser(paresJWT?.user)
        }
    }, [navigate, token])

    return (
        <AuthLayout title="Reset Your Password" subtitle="Create a new password to secure your account.">
            <Form
                name="reset-password"
                layout="vertical"
                className="ResetPassword__Form"
                onFinish={handleResetPassword}
                size="large"
            >
                <Form.Item
                    label="Password"
                    name="password"
                    rules={[
                        { required: true, message: 'Please create a password!' },
                        { min: 6, message: 'Password must be at least 6 characters!' },
                    ]}
                >
                    <Input.Password placeholder="Create a password" />
                </Form.Item>
                <Form.Item
                    label="Confirm Password"
                    name="confirmPassword"
                    dependencies={['password']}
                    rules={[
                        { required: true, message: 'Please confirm your password!' },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('password') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('The confirm password do not match!'));
                            },
                        }),
                    ]}
                >
                    <Input.Password placeholder="Re-enter your password" />
                </Form.Item>

                <Form.Item>
                    <Button
                        type="primary"
                        htmlType="submit"
                        size="large"
                        block
                        className="ResetPassword__Button"
                    >
                        Reset Password
                    </Button>
                </Form.Item>
            </Form>

            <Typography.Paragraph className="ResetPassword__BackToLogin">
                Remember your password?{' '}
                <a href={getRoutes().login.route()} className="ResetPassword__LoginLink">
                    Back to Login
                </a>
            </Typography.Paragraph>
        </AuthLayout>
    );
};

export default ResetPassword;
